export default "/images/ico-favorite.svg?fa7b3f58ed568921b3c33b3a5615cc3f";